"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_FILES = void 0;
exports["default"] = sendFiles;
var SEND_FILES = 'WEB_CHAT/SEND_FILES';

// TODO: [P1] We could obsolete this or dispatch { type: SEND_MESSAGE } insetad.
exports.SEND_FILES = SEND_FILES;
function sendFiles(files) {
  return {
    type: SEND_FILES,
    payload: {
      files: files
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX0ZJTEVTIiwiZXhwb3J0cyIsInNlbmRGaWxlcyIsImZpbGVzIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZW5kRmlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9GSUxFUyA9ICdXRUJfQ0hBVC9TRU5EX0ZJTEVTJztcblxuLy8gVE9ETzogW1AxXSBXZSBjb3VsZCBvYnNvbGV0ZSB0aGlzIG9yIGRpc3BhdGNoIHsgdHlwZTogU0VORF9NRVNTQUdFIH0gaW5zZXRhZC5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNlbmRGaWxlcyhcbiAgZmlsZXM6IHJlYWRvbmx5IFJlYWRvbmx5PHtcbiAgICBuYW1lOiBzdHJpbmc7XG4gICAgc2l6ZTogbnVtYmVyO1xuICAgIHVybDogc3RyaW5nO1xuICAgIHRodW1ibmFpbD86IHN0cmluZztcbiAgfT5bXVxuKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VORF9GSUxFUyxcbiAgICBwYXlsb2FkOiB7IGZpbGVzIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VORF9GSUxFUyB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsVUFBVSxHQUFHLHFCQUFxQjs7QUFFeEM7QUFBQUMsT0FBQSxDQUFBRCxVQUFBLEdBQUFBLFVBQUE7QUFDZSxTQUFTRSxTQUFTQSxDQUMvQkMsS0FLSSxFQUNKO0VBQ0EsT0FBTztJQUNMQyxJQUFJLEVBQUVKLFVBQVU7SUFDaEJLLE9BQU8sRUFBRTtNQUFFRixLQUFLLEVBQUxBO0lBQU07RUFDbkIsQ0FBQztBQUNIIn0=